import { cn } from '@v2/shared/lib/utils';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import { footerLinkFor } from './links';

/**
 * The one thing in an institutional rail that is not an institutional page: the way on.
 *
 * Every brand's Institutional layout passes this as its SideMenu footer, and there is
 * nothing brand-specific left in it once they do — both destinations are paths all four
 * storefronts serve, and `primary` is themed per brand by v2.css, so the button comes out
 * in DiscountMags' red, TopMags' rose, MagSpot's blue and MagZoom's indigo without being
 * told which it is on.
 *
 * What it says depends on the page: shopping almost everywhere, and the visitor's orders
 * on a page they opened because something had gone wrong. `links.ts` is the list of which
 * is which; the styling is the same either way, and is stated once, here.
 */
export default function SideMenuFooterLink({ activePath }: { activePath?: string }) {
  const { buildUrl } = useUrlGenerator();
  const { label, href } = footerLinkFor(activePath);

  return (
    <a
      href={buildUrl(href)}
      className={cn(
        'block rounded-lg border border-solid border-primary px-4 py-2.5',
        'text-center text-sm font-semibold uppercase tracking-wide text-primary no-underline',
        'transition-colors hover:bg-primary hover:text-white'
      )}
    >
      {label}
    </a>
  );
}
